import {Shell} from '@/entryPoints/b2c/shell';
import router from '@/familyDetailsPage/router';
import FamilyDetailsPageApp from '@/familyDetailsPage/FamilyDetailsPageApp.vue';

// Legacy Modules
import player from '@/modules/Players';

// Styling
import '@sassRoot/entryPoints/b2c/family-details.scss';

class FamilyDetails extends Shell {
  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();
  }
}

const familyDetails = new FamilyDetails({FamilyDetailsPageApp}, router);

familyDetails.preLoadInits();
familyDetails.initializeVue();

$(window).on('load', () => {
  familyDetails.globalDocumentReadyInits();

  // FDP Videos
  player();
});

$(window).on('load', () => {
  familyDetails.globalOnLoadInits();
});
